<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-row class="topRects" type="flex" justify="space-between">
      <van-col span="5" class="rect"><div @click="onGotoList('WAIT')"><span>{{ dataNum.numWait }}</span><br>待处理</div></van-col>
      <van-col span="5" class="rect"><div @click="onGotoList('WAITPAY')"><span>{{ dataNum.numWaitPay }}</span><br>待确认</div></van-col>
      <van-col span="5" class="rect"><div @click="onGotoList('PROCESSING')"><span>{{ dataNum.numDo }}</span><br>处理中</div></van-col>
      <van-col span="5" class="rect"><div @click="onGotoList('FINISH')"><span>{{ dataNum.numFinish }}</span><br>已颁发</div></van-col>
    </van-row>

    <div class="fastRect">
      <div class="title">快速颁发</div>
      <FieldSelect v-model="dataForm.certificationLocation" :list="countryList" label="签发国" placeholder="请选择签发地" @change="onCountryChange" />
      <van-field
        v-if="dataForm.certificationLocation ==='CHN'"
        v-model="zip"
        required
        clearable
        label="签发地"
        placeholder="选择省/市/区"
        readonly
        @click="selectArea"
      />
      <van-field
        v-model="dataForm.certificationPostCode"
        clearable
        label="邮编"
        maxlength="10"
        placeholder="签发地邮政编码"
      />
      <FieldSelect :list="picTypeGroup" label="机构" placeholder="请选择潜水组织" @change="onPicTypeGroupChange" />
      <FieldSelect v-model="baseDm" :list="proCertificate" label="教练" placeholder="请选择教练证书" @change="onProCertificateChange" @open="onProCertificateOpen" />
      <FieldSelect :list="picType" label="类型" placeholder="请选择证书类型" @change="onPicTypeChange" />
      <FieldSelect :list="picCourse" label="证书" placeholder="请选择证书" @change="onPicCourseChange" />
      <van-field
        v-model="dataForm.remark"
        clearable
        label="备注"
        maxlength="32"
        placeholder="请填写对用户的备注昵称"
      />
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>服务</span></div>
        <div class="van-cell__value"><van-checkbox v-model="dataForm.isFastService" :checked-color="GetColorMain()" @change="onChangeService">急速认证 (30分钟内出证)</van-checkbox></div>
      </div>
      <!-- <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>实体卡</span></div>
        <div class="van-cell__value"><van-checkbox v-model="dataForm.isPhysicsCard" @change="onChangeService">非潜水机构官方定制卡</van-checkbox></div>
      </div> -->
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><span>价格</span></div>
        <div class="van-cell__value" style="text-align:left">￥{{ totalPrice?ShowMoney(totalPrice):'0.00' }}</div>
      </div>
      <van-row gutter="10" class="buttons">
        <van-col span="12"><van-button type="default" plain :color="GetColorMain()" style="width:100%;" :loading="buttonLoading" @click="onCreteaNew">直接发证</van-button></van-col>
        <van-col span="12"><van-button type="danger" :color="GetColorMain()" style="width:100%" :loading="buttonLoading" @click="onShareReg">邀请用户填信息</van-button></van-col>
      </van-row>
    </div>

    <div class="listRect">
      <van-row gutter="20">
        <van-col span="6">状态</van-col>
        <van-col span="6">用户</van-col>
        <van-col span="6">证书</van-col>
        <van-col span="6">日期</van-col>
      </van-row>

      <van-row v-for="(item,index) in list" :key="index" gutter="20" class="dataLine">
        <div @click="onSelectPic(item)">
          <van-col span="6">{{ GetEnumText('Em_DivePicState', item.state) }}<br>{{ item.remark }}</van-col>
          <van-col span="6">{{ item.customerInfo?item.customerInfo.lastName:'' }} {{ item.customerInfo?item.customerInfo.firstName:'' }}</van-col>
          <van-col span="6">{{ item.groupTeam }} {{ item.picCourse }}</van-col>
          <van-col span="6">{{ formatDate(item.createTime,"yyyy/MM/dd\r\nhh:mm:ss",true) }}</van-col>
        </div>
      </van-row>

      <div v-if="list.length==0" class="empty">
        暂无数据
      </div>
    </div>
    <van-popup v-model="showAreaSelect" position="bottom">
      <van-area ref="pickerArea" :value="dataForm.certificationZip==undefined?'110000':dataForm.certificationZip.toString()" :loading="arealoading" :area-list="areaData" @confirm="confirmArea" @cancel="onCancelPicker" />
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Dialog, Button, Field, Switch, Area, Popup, Checkbox } from 'vant'
import TopBar from '@/components/TopBar'
import FieldSelect from '@/components/FieldSelect'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Field.name]: Field,
    [Switch.name]: Switch,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Area.name]: Area,
    TopBar,
    FieldSelect
  },
  data() {
    return {
      titleTop: '',
      title: '证书签发',
      backurl: '/pro/proIndex',
      test: '',
      buttonLoading: false,
      dataNum: {
        numWait: 0,
        numWaitPay: 0,
        numDo: 0,
        numFinish: 0
      },
      list: [],
      countryList: [],
      picTypeList: [],
      picTypeGroup: [],
      proCertificateBase: undefined,
      proCertificate: [],
      picTypeGroupSelect: undefined,
      picType: [],
      picTypeSelect: undefined,
      picCourse: [],
      picCourseSelect: undefined,
      selectPic: undefined,
      totalPrice: undefined,
      dataForm: {
        picTypeId: undefined,
        isFastService: false,
        isPhysicsCard: false,
        remark: '',
        isShare: false,
        certificationLocation: '',
        certificationZip: undefined,
        certificationPostCode: undefined,
        proCertificationId: undefined
      },
      zip: [],
      showAreaSelect: false,
      areaData: undefined,
      arealoading: false,
      baseDm: undefined
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.initDataNum()
    this.initType()
    this.initCountryList()
    this.initList()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onCancelPicker() {
      this.showAreaSelect = false
    },
    confirmArea(selectList) {
      var title = ''
      var zipId = 0
      selectList.forEach(item => {
        title += item.name + ' '
        zipId = item.code
      })
      this.zip = title
      this.dataForm.certificationZip = zipId
      this.showAreaSelect = false
    },
    selectArea() {
      this.showAreaSelect = true
      this.readAreaData()
    },
    readAreaData() {
      if (this.areaData !== undefined) {
        return
      }
      this.arealoading = true
      request({
        url: '/data/getArea',
        method: 'post'
      }).then(Response => {
        this.areaData = Response
        this.arealoading = false
      })
    },
    onGotoList(type) {
      console.log('onGotoList', type)
      this.$router.push('/pic/picList?type=' + type)
    },
    onCreteaNew() {
      if (!this.dataForm.picTypeId) {
        MyNotify('error', '请选择证书')
        return
      }
      if (!this.dataForm.proCertificationId) {
        MyNotify('error', '请选择教练')
        return
      }
      if (this.dataForm.certificationLocation === 'CHN' && !this.dataForm.certificationZip) {
        MyNotify('error', '请选择签发地')
        return
      }
      Dialog.confirm({
        title: '直接发证',
        message: '是否要生成订单并直接填写证书信息?'
      }).then(() => {
        this.buttonLoading = true
        this.onShareRegDo(false)
      })
    },
    onShareReg() {
      if (!this.dataForm.picTypeId) {
        MyNotify('error', '请选择证书')
        return
      }
      if (!this.dataForm.proCertificationId) {
        MyNotify('error', '请选择教练')
        return
      }
      if (this.dataForm.certificationLocation === 'CHN' && !this.dataForm.certificationZip) {
        MyNotify('error', '请选择签发地')
        return
      }
      Dialog.confirm({
        title: '邀请用户完善信息',
        message: '是否要生成订单并邀请用户完善证书信息？'
      }).then(() => {
        this.buttonLoading = true
        this.onShareRegDo(true)
      })
    },
    onShareRegDo(isShare) {
      this.dataForm.isShare = isShare
      request({
        url: '/Pro/PicCreateFast',
        method: 'post',
        data: this.dataForm
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '证书签发订单创建成功')
        var id = Response.data
        if (isShare) {
          this.$router.push('/pic/picShare/' + id)
        } else {
          this.$router.push('/pic/editCustomerInfo/' + id)
        }
      })
    },
    onSelectPic(item) {
      if (item.state === 'CREATE' && item.isShare) {
        this.$router.push('/pic/picShare/' + item.picId)
      } else {
        this.$router.push('/pic/picInfo/' + item.picId)
      }
    },
    onChangeService() {
      var price = 0.0
      if (!this.selectPic) {
        this.totalPrice = 0
        return
      }
      price = this.selectPic.price
      if (this.dataForm.isFastService) {
        price += this.selectPic.priceFastService
      }
      if (this.dataForm.isPhysicsCard) {
        price += this.selectPic.pricePhysicsCard
      }
      this.totalPrice = price
    },
    initList() {
      request({
        url: '/Pro/PicList',
        method: 'post',
        data: {
          page: 1,
          limit: 20
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.list = Response.data.rows
      })
    },
    initProCertificate(callback) {
      if (this.proCertificateBase) {
        if (callback) {
          callback()
        }
      }
      request({
        url: '/user/getUserProCertificate',
        method: 'post'
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.proCertificateBase = Response.data.list
        if (callback) {
          callback()
        }
      })
    },
    initType(callback) {
      request({
        url: '/Pro/getPicTypeList',
        method: 'post'

      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.picTypeList = Response.data
        this.picTypeGroup = []
        this.picTypeList.forEach(item => {
          var same = this.picTypeGroup.find(el => el.value === item.groupTeam)
          if (!same) {
            this.picTypeGroup.push({
              text: item.groupTeam,
              value: item.groupTeam
            })
          }
        })
      })
    },
    initCountryList(callback) {
      request({
        url: '/Pro/getPadiCountry',
        method: 'post'
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.countryList = []
        Response.data.forEach(item => {
          this.countryList.push({ text: item.name, value: item.code3 })
        })
      })
    },
    initDataNum() {
      request({
        url: '/Pro/getPicNum',
        method: 'post'
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.dataNum = Response.data
        this.dataForm.certificationPostCode = this.dataNum.lastPostCode
        this.dataForm.certificationLocation = this.dataNum.lastCountry
        this.dataForm.certificationZip = this.dataNum.lastZip
        this.zip = this.dataNum.zipString
        this.baseDm = this.dataNum.lastProCertifyingId
        this.dataForm.proCertificationId = this.dataNum.lastProCertifyingId
      })
    },
    onCountryChange(select) {
      this.dataForm.certificationLocation = select.value
    },
    onProCertificateChange(select) {
      console.log('onProCertificateChange', select)
      this.dataForm.proCertificationId = select.value
    },
    onProCertificateOpen(count) {
      console.log('onProCertificateOpen', count)
      if (count === 0) {
        Dialog.alert({
          title: '无匹配教练证书',
          message: '请先联系工作人员添加教练证书!'
        })
      }
    },
    onPicTypeGroupChange(select) {
      console.log('onPicTypeGroupChange', select)
      this.picType = []
      this.picTypeGroupSelect = select
      if (!select) {
        return
      }
      this.picTypeList.forEach(item => {
        if (item.groupTeam === select.value) {
          var same = this.picType.find(el => el.value === item.type)
          if (!same) {
            this.picType.push({
              text: item.type,
              value: item.type
            })
          }
        }
      })
      this.initProCertificate(() => {
        console.log('initProCertificate', this.proCertificateBase)
        this.proCertificateBase.forEach(item => {
          if (item.groupTeam === select.value) {
            this.proCertificate.push({
              text: item.cerificateName + '(' + item.cerificateId + ')',
              value: item.cerificateId
            })
          }
        })
      })
    },
    onPicTypeChange(select) {
      console.log('onPicTypeChange', select)
      this.picTypeSelect = select
      this.picCourse = []
      if (!select) {
        return
      }
      this.picTypeList.forEach(item => {
        if (item.type === select.value) {
          var same = this.picType.find(el => el.value === item.course)
          if (!same) {
            this.picCourse.push({
              text: item.courseShow,
              value: item.courseShow
            })
          }
        }
      })
    },
    onPicCourseChange(select) {
      console.log('onPicCourseChange', select)
      this.picCourseSelect = select
      this.selectPic = undefined
      this.dataForm.picTypeId = undefined
      this.picTypeList.forEach(item => {
        if (this.picTypeGroupSelect.value === item.groupTeam &&
            this.picTypeSelect.value === item.type &&
            this.picCourseSelect.value === item.courseShow) {
          this.selectPic = item
        }
      })
      console.log('selectPic', this.selectPic)
      this.dataForm.picTypeId = this.selectPic.picTypeId
      this.onChangeService()
    }
  }
}
</script>
<style scoped>
.topRects{
    margin-top:1em;
    padding: 0 1em;
}
.topRects .rect{
    background-color: #fff;
    padding: 1em 0;
    text-align: center;
    border-radius: 0.3em;
}
.topRects .rect span{
    font-size: 1.2em;
    font-weight: 700;
}

.fastRect{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 0.5em;
    margin: 1em;
}
.fastRect .title{
    font-size: 1.1em;
    font-weight: 700;
    padding: 0.3em 0 0.3em 0.9em;
}
.buttons{

    padding: 0.5em 16px;
}
.listRect{
      background-color: #fff;
    border-radius: 0.3em;
    padding: 0.5em;
    margin: 1em;
    text-align: center;
}
.listRect .dataLine{
    font-size: 0.8em;
    color: #999;
    padding-bottom: 0.3em;
    border-bottom: 1px solid #eee;
}
.listRect .title{
    padding: 0.3em 0;
}
.listRect .dataLine:last-child{
    border-bottom: none;
}
.listRect .empty{
  color: #999;
  text-align: center;
  padding: 3em 0;
}
</style>
